// removed by extract-text-webpack-plugin
module.exports = {"scheduleDetails":"ScheduleDetails__scheduleDetails--24HYP"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/ScheduleDetails/ScheduleDetails.css
// module id = oDLn
// module chunks = 47